import { NgClass } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    inject,
    Input,
    OnInit,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';

@Component({
    selector: 'app-user-menu-rapallo',
    standalone: true,
    imports: [MatIconModule, NgClass],
    templateUrl: './user-menu.component.html',
    styleUrls: [
        '../../../../../../assets/styles/bootstrap-italia-comuni.min.css',
        '../../../../../../assets/styles/rapallo-style.css',
    ],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
    constructor(
        private _httpClient: HttpClient,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
    ) {}

    dropdownOpen = false; // Variabile per tracciare lo stato di apertura

    @Input() fullName!: string;
    user: User;

    userService = inject(UserService);

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen; // Alterna l'apertura e la chiusura
    }

    signOut(): void {
        this.userService
            .signOut()
            .subscribe(
                () =>
                    (location.href =
                        'https://www.comune.rapallo.ge.it/index.php?azione=logoutSpid'),
            );
    }
}
